import axios from 'axios';

const getAuthHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const listUrls = async ({ projectPid, page = 1, limit = 10, search = '', crawlStatus = '', isAddedByUser }) => {
  const payload = { projectPid, page, limit, search, crawlStatus };
  if (isAddedByUser !== undefined) {
    payload.isAddedByUser = isAddedByUser;
  }
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/list`,
    payload,
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const createUrl = async ({ projectPid, url }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/create`,
    { projectPid, url, isToScan: true, isBlock: false },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const updateUrl = async ({ urlPid, projectPid, url, blocktype }) => {
  const response = await axios.put(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/update`,
    { urlPid, projectPid, url, isToScan: false, isBlock: false, blocktype },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const deleteUrl = async ({ urlPid }) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/delete`,
    { data: { urlPid }, headers: getAuthHeader() },
  );
  return response.data;
};

export const refreshUrl = async ({ urlPid }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/refresh`,
    { urlPid },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const refreshUrlsBulk = async ({ urlPids }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/refresh-bulk`,
    { urlPids },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const listBlockRules = async ({ projectPid }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/blocks/list`,
    { projectPid },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const createBlockRule = async ({ projectPid, pattern, blocktype }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/blocks/create`,
    { projectPid, pattern, blocktype },
    { headers: getAuthHeader() },
  );
  return response.data;
};

export const deleteBlockRule = async ({ projectPid, blockPid }) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/projects/urls/blocks/remove`,
    { projectPid, blockPid },
    { headers: getAuthHeader() },
  );
  return response.data;
};
